<template>
  <!-- "Any AIB" caveat (DEV-626) · deliberately not dismissable: the workaround stays available, but
       whoever uses it must see what it means for the beneficiary's evidence every time. Margin is left
       to the caller via class fallthrough. -->
  <div class="advisory-note" data-test="any-aib-caveat">
    <FontAwesomeIcon
      :icon="['far', 'circle-info']"
      class="flex-shrink-0 mt-1"
    />
    <div>
      <div class="fw-semibold">
        {{ t("cancellation_rules.any_aib_notice.title") }}
      </div>
      <div class="small mb-0">
        {{ t("cancellation_rules.any_aib_notice.message") }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>
